<template>
	<div class="main-container" :class="{ 'drawer-open': drawerOpen }">
    <div class="wp-nav" v-if="isRouteLayout">
      <div class="wp-nav-inner">
      <div class="logo logo--pc" >
        <a :href="homeLink" @click.prevent="toUrl(homeLink)">
          <img :src="logoUrl" alt="logo" title="logo" />
        </a>
      </div>
      <a class="logo logo--mobile" :href="homeLink" @click.prevent="toUrl(homeLink)">
        <img v-if="mobileLogoUrl" :src="mobileLogoUrl" alt="logo" class="logo-img" />
        <span v-else class="logo-img logo-img--empty"></span>
      </a>
      <ul class="nav-list" >
        <li
          v-for="item in topData"
          :key="item.link + item.name"
          :class="{ active: isActiveNav(item) }"
          @click="toUrl(item.link)"
        >{{ displayName(item.name) }}</li>
      </ul>
      <div class="tool-btn">
        <el-dropdown class="lang-switch lang-switch--desktop" trigger="click" placement="bottom" @command="langSelect">
          <span class="lang-switch__trigger">
            <img class="lang-globe" src="../assets/img/lang.png" alt="" />
            <span class="lang-code">{{ lang === 'en' ? 'En' : '中' }}</span>
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="lang-dropdown">
            <el-dropdown-item command="zh_CN" :class="{ active: lang !== 'en' }">简体中文</el-dropdown-item>
            <el-dropdown-item command="en" :class="{ active: lang === 'en' }">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div v-if="user" class="login-register-two user-avatar--desktop">
          <el-dropdown trigger="click" placement="bottom" @command="handleCommand" >
            <span class="el-dropdown-link">
              <span class="one">
				<img class="user-avatar" src="../assets/img/user.png" alt="" />
				</span>
            </span>
            <el-dropdown-menu slot="dropdown" class="menucss" >
              <el-dropdown-item command="atoul"><img src="../assets/img/renxiang.png" alt="">{{ $t('User Center') }}</el-dropdown-item>
              <el-dropdown-item command="logout"><img src="../assets/img/Logoutto.png" alt="">{{ $t('Logout') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="contenent user-avatar--desktop" v-if="!$route.query.token">
          <div class="photopeople" v-if="!user&&loginurl">
            <router-link  to="/login" class="login-link" style="text-decoration: none">
			        <img class="user-avatar" src="../assets/img/user.png" alt="" />
            </router-link>
          </div>
        </div>
        <button type="button" class="menu-btn menu-btn--mobile" aria-label="menu" @click="openDrawer">
          <span class="menu-btn__icon menu-btn__icon--empty">
		  	<img src="../assets/img/List.png" alt="">
		  </span>
        </button>
      </div>
      </div>
    </div>

    <div class="mobile-drawer" v-if="isRouteLayout" :class="{ 'is-open': drawerOpen }">
      <div class="mobile-drawer__mask" @click="closeDrawer"></div>
      <div class="mobile-drawer__panel">
        <div class="drawer-header">
          <img
            v-if="user || loginurl"
            class="drawer-header__user"
            src="../assets/img/user.png"
            alt=""
            @click="onDrawerUserClick"
          />
          <span v-else class="drawer-header__user drawer-header__user--empty"></span>
          <button type="button" class="drawer-header__close" @click="closeDrawer">×</button>
        </div>
        <div class="drawer-body">
          <div class="drawer-brand">
            <img v-if="mobileLogoUrl" src="../assets/img/11b660cf7f3e08326e3d32561df988f4 (1).png" alt="" class="drawer-brand__img" />
            <span v-else class="drawer-brand__img drawer-brand__img--empty"></span>
          </div>
          <nav class="drawer-nav">
            <a
              v-for="item in topData"
              :key="'d-' + item.link + item.name"
              href="javascript:;"
              class="drawer-nav__link"
              :class="{ 'drawer-nav__link--active': isActiveNav(item) }"
              @click.prevent="onDrawerNavClick(item.link)"
            >{{ displayName(item.name) }}</a>
          </nav>
          <div class="drawer-footer">
            <button
              type="button"
              class="lang-drawer-item"
              :class="{ active: lang !== 'en' }"
              @click="langSelect('zh_CN'); closeDrawer()"
            >
              <span class="lang-badge lang-badge--empty">
				<img src="../assets/img/zh.png" alt="">
			  </span>
              <span>简体中文</span>
              <span class="lang-drawer-item__arrow lang-drawer-item__arrow--empty">
				<img src="../assets/img/right.png" alt="">
			  </span>
            </button>
            <button
              type="button"
              class="lang-drawer-item"
              :class="{ active: lang === 'en' }"
              @click="langSelect('en'); closeDrawer()"
            >
              <span class="lang-badge lang-badge--empty">
				<img src="../assets/img/en.png" alt="">
			  </span>
              <span>English</span>
              <span class="lang-drawer-item__arrow lang-drawer-item__arrow--empty">
				<img src="../assets/img/right.png" alt="">
			  </span>
            </button>
          </div>
        </div>
      </div>
    </div>

		<router-view />
		<wp-footer v-if="isRouteLayout" :friend-link="friendLink" :footer-data="footer" />
	</div>
</template>

<script>
	import { getPublicInfo, resolvePublicAssetUrl } from '../api';
	import { setStore, keys, getStore, clearStore } from '../store';
	import { EventBus } from '../utils';
	import i18n from '../locales/i18n';
	import WpFooter from './WpFooter.vue';

	export default {
		components: { WpFooter },
		data() {
			return {
				user: null,
				lang: '',
				seen:false,
				ulseen:false,
				drawerOpen:false,
				loginurl:true,
				topData: [],
				friendLink: [],
				footer: null,
				isMobile: typeof window !== 'undefined' && window.innerWidth <= 767,
			};
		},
		beforeRouteUpdate(to, from, next){
		if(to.fullPath.indexOf('login')>-1){
			this.loginurl=false
		}
		else{
			this.loginurl=true
		}
        next()
    },
		created(){
			this.id=this.$route.params.id
		},
		mounted() {
			if(window.location.href.indexOf('login')>-1){
				this.loginurl=false
			}else{
				this.loginurl=true
			}
			this.user = getStore(keys.user);
			EventBus.$on('login', () => {
				this.user = getStore(keys.user);
			});
			this.lang = i18n.locale;
			this.fetchPublicInfo();
			this.updateIsMobile();
			window.addEventListener('resize', this.updateIsMobile);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateIsMobile);
			this.closeDrawer();
		},
		watch: {
			'$i18n.locale'(val) {
				this.lang = val;
				this.fetchPublicInfo();
			},
		},
		computed: {
			langText() {
				return this.lang === 'en' ? 'English' : '简体中文';
			},
			entres(){
				return (window.innerWidth > 768 ? false : true)&&this.user? false : true;
			},
			logoUrl() {
				const path = this.footer && this.footer.top_logo;
				return resolvePublicAssetUrl(path) || require('../assets/img/logo.png');
			},
			mobileLogoUrl() {
				const path = this.footer && (this.footer.top_logo_mobile || this.footer.top_logo);
				return resolvePublicAssetUrl(path) || require('../assets/img/logo.png');
			},
			homeLink() {
				const home = this.topData && this.topData[0];
				return (home && home.link) || 'https://panda.yuejike.com/';
			},
			isRouteLayout() {
				const matched = this.$route.matched[0];
				return matched && matched.name === 'navbar';
			},
		},
		methods: {
			updateIsMobile() {
				this.isMobile = window.innerWidth <= 767;
				if (!this.isMobile) this.closeDrawer();
			},
			openDrawer() {
				this.drawerOpen = true;
				if (typeof document !== 'undefined') document.body.style.overflow = 'hidden';
			},
			closeDrawer() {
				this.drawerOpen = false;
				if (typeof document !== 'undefined') document.body.style.overflow = '';
			},
			onDrawerNavClick(url) {
				this.closeDrawer();
				this.toUrl(url);
			},
			onDrawerUserClick() {
				this.closeDrawer();
				if (this.user) {
					window.open('/parent/#/', '_self');
					return;
				}
				if (this.loginurl) {
					this.$router.push({ path: '/login' }).catch(() => {});
				}
			},
			async fetchPublicInfo() {
				try {
					const data = await getPublicInfo();
					this.topData = (data && data.topData) || [];
					this.friendLink = (data && data.friendLink) || [];
					this.footer = (data && data.footer) || null;
					this.applySeo();
				} catch (e) {
					console.error(e);
				}
			},
			applySeo() {
				const current = this.topData.find(item => this.isActiveNav(item)) || this.topData[2] || this.topData[0];
				if (!current) return;
				if (current.title) document.title = current.title;
				this.setMeta('keywords', current.keywords);
				this.setMeta('description', current.description);
			},
			setMeta(name, content) {
				if (!content) return;
				let el = document.querySelector(`meta[name="${name}"]`);
				if (!el) {
					el = document.createElement('meta');
					el.setAttribute('name', name);
					document.head.appendChild(el);
				}
				el.setAttribute('content', content);
			},
			displayName(name) {
				return String(name || '').replace(/\n/g, '').trim();
			},
			isActiveNav(item) {
				if (!item || !item.link) return false;
				const link = String(item.link);
				return /\/goods/i.test(link) || /panda\.edu\.yuejike\.com/i.test(link);
			},
			isLocalGoodsLink(url) {
				return /\/goods/i.test(url) || /panda\.edu\.yuejike\.com/i.test(url);
			},
			handleCommand(command) {
				if(command=='atoul'){
						window.open("/par/#/","_self")

				}
				else if(command=='logout'){
					this.logout() ;
				}
			},
			openover(){
				this.ulseen=!this.ulseen;
			},
			onMouseOver() {
			this.seen=true
			},
			onMouseOut() {
			this.seen=false
			},
			langSelect(command) {
				if (!command || command === this.lang) return;
				setStore(keys.lang, command);
				this.$i18n.locale = command;
				this.lang = command;
				this.$route.params.id = '';
				location.reload();
			},
			langChange() {
				this.langSelect(this.lang === 'en' ? 'zh_CN' : 'en');
			},
			logout() {
				clearStore();
				this.user = null;
				this.$router.push({ path: '/' });
				location.reload();

			},
			toUrl(url){
				if (!url) return;
				if (this.isLocalGoodsLink(url)) {
					const path = url.replace(/^https?:\/\/[^/]+/i, '');
					const goodsPath = path.replace(/^\/goods/i, '') || '/';
					if (goodsPath === '/' || goodsPath.startsWith('/?') || /^\/(zh_CN|en|cn)/i.test(goodsPath)) {
						this.$router.push({ path: '/' }).catch(() => {});
						return;
					}
				}
            	window.location.href = url;
			},
		},
	};
</script>

<style lang="less" scoped >
.mobile-menu{
	 cursor:pointer;
	 img{
		 cursor:pointer;
	 }
}
  .el-dropdown-link{
	  display: flex;
	  align-items: center;
	  img{
		  cursor:pointer;
	  }
  }
  .login-link{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
    padding: 0;
    border: none;
    box-sizing: border-box;
  }
  .lang-switch{
    margin-right: 16px;
    line-height: 1;
    .lang-switch__trigger{
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
      color: #fff;
      font-size: 1.25rem;
      font-weight: 500;
      line-height: 1;
      user-select: none;
      outline: none;
    }
    .lang-globe{
      display: block;
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      object-fit: contain;
    }
    .lang-code{
      line-height: 1;
      font-weight: 500;
    }
    .el-icon-arrow-down{
      font-size: 0.8125rem;
      margin-left: 0.25rem;
      color: #fff;
    }
  }
  .user-avatar{
    display: block;
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
  .user-icon{
    color: #fff;
    font-size: 16px;
    line-height: 1;
  }
   .change_lang{
	   img{
		   cursor:pointer;
		   margin-left: 5px;
	   }
	   img+img{
		   margin-right: 5px;
	   }
   }

   li{

	   position: relative;
	   .nav-header{
		   z-index: 99999999999999;
		   position: absolute;
		   width: 190px;
		   padding:  15px 10px;
		//    height: 100px;
		    border-radius: 25px;
		background: #FFFFFF;
		box-shadow: rgba(0, 0, 0, 0.11) 0px 0px 14px 4px;
		   top: 40px;
		   left: -20px;
		   display: flex;
		//    justify-content:space-around;
		   div{
			   margin: 0  0px 0 20px;
			   display: flex;
			   flex-direction:column;
			   span{
				   line-height: 30px;
				   text-align: left;
				   font-size: 18px;
			   }
			   span:hover{
				       color: #ff6440;
			   }

		   }
	   }
   }
   .contenent{
	   display: flex;
	   align-items:center;
	    a{
		  display: flex;
	   align-items:center;

	   }

   }
	// pc
	@media screen and (min-width: @device) {
		.menucss{
			li{
				display: flex;
				align-items: center;
				font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
				font-style: normal;
				font-weight: 400;
				font-size: 15px;

				color: rgba(0, 0, 0, 0.85);
			}
			img{
				width: 18px;
				height: 19px;
				margin-right: 20px;
			}
		}
		.photopeople{
			display: flex;
      border: none;
      border-radius: 18px;
      height: 32px;
			img{
				width: 26px;
			}
		}
		.mobile-menu-nav{
			display: none;
		}
		.nav-list {
			display: flex;
			flex: 1;
			min-width: 0;
			justify-content: center;
			align-items: center;
			gap: 0;
			li{
				margin: 0;
				font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
				font-style: normal;
				font-weight: 400;
				font-size: 1.25rem;
				color: #fff;
				padding: 0.6875rem 1.125rem;
				border-radius: 1.625rem;
				line-height: 1.2;
				letter-spacing: 0.02em;
				transition: background-color 0.15s ease, color 0.15s ease;
				cursor: pointer;
				white-space: nowrap;
				&:hover{
					background: rgba(255, 255, 255, 0.16);
					color: #fff;
				}
				&.active{
					background: #fff;
					color: #B50604;
					font-weight: 700;
				}
			}
		}

		.login-register {
			display: flex;
		}

		.mobile-menu-dis {
			display: none;
		}
		.pccss{
			display: none;
		}
		.login-register-two{
			cursor: pointer;
			display: flex;
			align-items:center;
			font-weight: 400;
			font-size: 12px;
			height: 32px;
			line-height: 20px;
			color: #fff;
			font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
			border: none;
			border-radius: 0;
			padding: 0;
			margin-right: 0;
			box-sizing: border-box;

			.one{
				display: flex;
				align-items: center;
				text-align: center;
				height: auto;
				margin-right: 0;
        color: #fff;
			}
			.two{
				font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
				font-weight: 500;
				font-size: 12px;
				color: #fff;
			}
		}
		.logout{
			display: flex;
			align-items:center;
		}
    //pc
		.wp-nav{
      background-color: #B50604;
      height: 110px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0;
      box-sizing: border-box;
			.wp-nav-inner{
				width: 1200px;
				max-width: 100%;
				height: 100%;
				margin: 0 auto;
				padding: 0 16px;
				box-sizing: border-box;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
			}
			.logo{
				margin-left: 0;
				flex-shrink: 0;
				a{
					display: block;
					width: 88px;
					height: 88px;
					border-radius: 10px;
					overflow: hidden;
					background: #fff;
				}
				img{
					width: 100%;
					height: 100%;
					object-fit: contain;
					display: block;
					background: #fff;
				}
			}
			.tool-btn{
				min-width: 120px;
				justify-content: flex-end;
				gap: 4px;
			}

		}
	}
	.nav-list{
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		list-style: none;
		margin: 0;
		padding: 0;
		gap: 0;
		li{
			color: #fff;
			font-size: 1.25rem;
			font-weight: 400;
			padding: 0.6875rem 1.125rem;
			border-radius: 1.625rem;
			cursor: pointer;
			white-space: nowrap;
			line-height: 1.2;
			&:hover{
				background: rgba(255, 255, 255, 0.16);
				color: #fff;
			}
			&.active{
				background: #fff;
				color: #B50604;
				font-weight: 700;
			}
		}
		a{
			text-decoration: none;
			color: inherit;
		}
	}
  //pc
	.tool-btn {
		vertical-align: middle;
		display: flex;
		line-height: 50px;
		justify-content: flex-end;
		align-items: center;
		color: #fff;
		.contenent{
			display: flex;
			align-items: center;
		}
		.el-button {
			color: #B50604;
			background-color: #4b69fe;
			color: white;
			border-radius: 20px;
		}
		.tbl > span {
			color: #B50604;
			vertical-align: sub !important;
		}
	}

	.login-register {
		font-weight: 600;
		font-size: 14px;
		color: #4b69fe;
		margin-left: 16px;
		cursor: pointer;
		// display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.lang {
		// margin-left: 28px;
		cursor: pointer;
		display: flex;
		align-items: center;

		img {
			vertical-align: sub;
			width: 21px;
			height: 20px;
		}

		span {
			font-size: 10px;
			margin-left: 5px;
		}

		.lang-text {
			margin: 0 5px 0 10px;
		}
	}

	.main-container {
		font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
		display: flex;
		flex-direction: column;
		// max-width: 1076px;
		margin-left: auto;
		margin-right: auto;
	}

	.nav-btn {
		border: 1px solid #4b69fe;
		border-radius: 20px;
		height: 28px;
		min-width:91px;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content:center;
		padding: 0 15px;
		cursor: pointer;
		margin-left: 24px;
		a{

			text-align: center;
		}
	}

	.background {
		background-color: #4b69fe;
		color: white;
	}
	.free-trial a{
		color: white;
		text-decoration: none;
		font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
		font-style: normal;
		font-weight: 600;
		font-size: 14px;
	}

	// 移动端
	@media screen and (max-width: @device) {
		.nav-li{
			display: flex;
			align-items: center;

		}
		.mobile-menu-nav .nav-li a{
			color: #FFFFFF;
			font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
			font-style: normal;
			font-weight: 600;
			font-size: 14px;
		}
		.nav-btn{
			width: 100%;
			margin:  0 20px;
			height: 32px;
		}
		.menucss{
			li{
				display: flex;
				align-items: center;
				font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
				font-style: normal;
				font-weight: 400;
				font-size: 14px;

				color: rgba(0, 0, 0, 0.85);
			}
			img{
				width: 13px;
				height: 13px;
				margin-right: 9px;
			}
		}
    //h5
		.tool-btn {
			justify-content: flex-end;
			padding:0 15px;

			div{
			div+div{
				margin-left: 18px;
			}
			}


		}
		.main-container{
			width: 100vw;
			// overflow: hidden;
		}
		.nav-list {
			display: none !important;
		}
		.lang-switch{
			margin-right: 8px;
		}
		.mobile-menu{
			display: flex;
			margin-left: 8px;
			img{
				width: 22px;
				height: 22px;
				filter: brightness(0) invert(1);
			}
		}
		.mobile-menu-nav{
			li.active{
				color: #B50604;
				font-weight: 600;
			}
		}
		 /deep/.el-dropdown{
			padding:0px;
			margin: 0px;
		}

		.login-register {

            .login-link{
						box-sizing: border-box;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						padding: 3px 10px;
						gap: 10px;
						width: 116px;
						height: 32px;

						flex: none;
						order: 0;
						flex-grow: 0;
              span{
				  width: auto;
                 height: 20px;
                  font-weight: 600;
                 font-size: 12px;
                 line-height: 20px;
                 display: flex;
                   align-items: center;
                 text-align: center;
                  font-feature-settings: 'salt' on;
                   color: #FFFFFF;
                   flex: none;
                   order: 1;
                   flex-grow: 0;
                     text-decoration:none;
			  }
			}
		}
    //h5
		.login-register-two{
			// position:relative;
			cursor: pointer;
			display: flex;
			align-items:center;
			// margin-right: 10px;
			font-weight: 400;
			font-size: 11px;
			height: 28px;
			line-height: 20px;
			color: #fff;
			font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
			border: none;
			border-radius: 0;
			padding: 0;
			img{
				width: 18px;
				height: 18px;
			}
			.one{
				text-align: center;
				font-size: 12px;
				margin-right: 0;
				color: #fff;
        i{
          border: none;
        }
			}
			.two{
				font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
				font-weight: 400;
				font-size: 11px;
				color: #fff;
			}
		}

		.free-trial {
			display: none !important;
		}

		.lang-text {
			display: none;
		}

		.mobile-menu {
			display: flex;
			// position: relative;
			// align-items: center;
			// margin-top: 10px;
			img {
				// width: 19.04px;
                // height: 18.5px;
				// margin: auto 16px auto 21px;
			}
		}
		.logout{
			img{
				width: 19.04px;
                height: 18.5px;
			}
		}
    //h5
		.wp-nav {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      background-color: #B50604;
      height: auto;
      min-height: 56px;
      padding: 0;
      box-sizing: border-box;
			.wp-nav-inner{
				width: 100%;
				max-width: 100%;
				height: 56px;
				padding: 0 12px;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
			.logo {
				margin: 0;
				width: 44px;
				flex-shrink: 0;
				a{
					width: 44px;
					height: 44px;
					border-radius: 6px;
				}
			}
			.tool-btn{
				min-width: auto;
			}
		}
		.lang-switch{
			margin-right: 10px;
			font-size: 13px;
		}
		.lang{
			line-height: 40px;
			// padding-right: 22px;
			/deep/.el-dropdown{
			   margin: 0 ;
			}
		}
		.lang .nav-btn {
			display: flex;
			width: 50px;
			justify-content: space-between;
		}
		.phonecss{
			display: none;
		}
		.wp-nav{
			.phonecss{
			display: none;
		}
		}
		.mobile-menu-nav{
			z-index: 99999;
			position: absolute;
			width: 100%;
			top: 60px;
			list-style: none;
			padding: 0px 0 30px;
			background: #FFFFFF;
			li{
				margin: 0 18px;
				border-bottom:1px solid #c4c4c4;
				line-height: 64px;
				font-size: 16px;
				height: 64px;

			}
			li:nth-child(7){
				border: none;
			}
			li:nth-child(1){
				display: flex;
				justify-content:space-between;
				i{
					height: 20px;
					margin: 10px 20px;
				}
			}
			a {
			text-decoration: none;
			}

			.router-link-active {
			text-decoration: none;
			// color: #000;
			}
			.lisee{
			height: 130px;
		}
		}
		.ul-header{
			z-index: 9999999999;
			transform:translateZ(1px);
			display: flex;
			 position: absolute;
		   width:90vw;
			left: calc(5vw - 18px);
		   padding: auto;
		//    height: 100px;
		    border-radius: 30px;
		background: #FFFFFF;
		box-shadow: rgba(0, 0, 0, 0.11) 0px 0px 14px 4px;
		   top: 50px;
		   display: flex;
		    flex-direction:column;
		   justify-content:space-around;
		   div{
			   margin: 10px 0px;
			   display: flex;
			   flex-direction:column;
			   span{
				   line-height: 30px;
				   padding-left: 20px;
				       color: #3B495E;
					       font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
						font-size: 18px;
						font-weight: 400;
			   }
			   span:hover{
				       color: #B50604;
			   }

		   }
		}
		.photopeople{
			display: flex;
			img{
				width: 17px;
			}
      i{
        color: #fff;
        border: 2px solid #fff;
      }
      span{
        color: #fff;
      }
		}
		.hamburger{
			align-items: center;

			img {
				// width: 17px;
                // height: 30px;
				// margin: auto 16px auto 21px;
				margin: 0;
			}
		}
	}

  .mobile-menu-nav{
	  li,a,li span,a span{
		  font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
			font-style: normal;
			font-weight: 400;
			font-size: 16px;
			color: #3B495E;
	  }
  }
	.nav-list .langcss,.langcss,.mobile-menu-nav .langcss {
	  font-weight: 600;
	  font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
  .menucss{
	background: #FFFFFF;
	box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
	border-radius: 2px;
}


/* ===== mobile header / drawer (panda-pc html2) — does not affect PC ===== */
.logo--mobile,
.menu-btn--mobile,
.mobile-drawer {
  display: none;
}

@media screen and (max-width: 767px) {
  .logo--pc,
  .nav-list,
  .lang-switch--desktop,
  .user-avatar--desktop,
  .mobile-menu-nav {
    display: none !important;
  }

  .logo--mobile {
    display: flex !important;
    align-items: center;
    flex-shrink: 0;
    width: auto !important;
    margin: 0 !important;
  }

  .logo--mobile .logo-img {
    width: 3.5rem;
    height: 2.625rem;
    object-fit: contain;
    display: block;
  }

  .logo--mobile .logo-img--empty {
    width: 3.5rem;
    height: 2.625rem;
    display: inline-block;
  }

  .menu-btn--mobile {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    margin-left: auto;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .menu-btn__icon--empty {
    display: block;
    width: 1.5rem;
    height: 1.5rem;
  }

  .wp-nav {
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex !important;
    flex-direction: row !important;
    justify-content: center;
    align-items: center;
    background: #fff !important;
    box-shadow: 0 0.0625rem 0.5rem rgba(0, 0, 0, 0.06);
    height: 68px !important;
    min-height: 68px !important;
    padding: 0 !important;
  }

  .wp-nav .wp-nav-inner {
    width: 100%;
    max-width: 100%;
    height: 68px !important;
    padding: 0 0.9375rem !important;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.75rem;
  }

  .wp-nav .tool-btn {
    margin-left: auto;
    min-width: auto !important;
    padding: 0 !important;
    gap: 1rem;
    line-height: 1;
  }

  .mobile-drawer {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 1000;
    visibility: hidden;
    pointer-events: none;
  }

  .mobile-drawer.is-open {
    visibility: visible;
    pointer-events: auto;
  }

  .mobile-drawer__mask {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    opacity: 0;
    transition: opacity 0.25s;
  }

  .mobile-drawer.is-open .mobile-drawer__mask {
    opacity: 1;
  }

  .mobile-drawer__panel {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: #f8f8f8;
    transform: translateX(100%);
    transition: transform 0.25s;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .mobile-drawer.is-open .mobile-drawer__panel {
    transform: translateX(0);
  }

  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 4.25rem;
    padding: 0 1.1875rem 0 1.625rem !important;
    background-color: #fff;
    box-sizing: border-box;
  }

  .drawer-header__user {
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    object-fit: cover;
    cursor: pointer;
  }

  .drawer-header__user--empty {
    display: inline-block;
  }

  .drawer-header__close {
    border: none;
    background: none;
    font-size: 1.75rem;
    cursor: pointer;
    color: #999;
    line-height: 1;
    padding: 0;
  }

  .drawer-body {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 5rem);
    background-color: #F9F9F9;
    padding: 1.9375rem 1.6875rem;
    box-sizing: border-box;
  }

  .drawer-brand {
    text-align: center;
    padding: 1.5rem 0 2.5rem;
  }

  .drawer-brand__img {
    width: 5rem;
    height: auto;
    display: block;
    object-fit: contain;
  }

  .drawer-brand__img--empty {
    height: 5rem;
  }

  .drawer-nav {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;
    padding-bottom: 42px;
  }

  .drawer-nav__link {
    font-size: 1.25rem;
    padding: 0.75rem 0;
    color: #000;
    font-weight: 400;
    text-decoration: none;
  }


  .drawer-footer {
    display: flex;
    gap: 0.15rem;
    background-color: #F9F9F9;
    margin-left: -20px;
    margin-top: auto;
    padding-top: 24px;
  }

  .lang-drawer-item {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    width: 35%;
    padding: 1.125rem 0.75rem;
    border: none;
    background: none;
    font-size: 1rem;
    cursor: pointer;
    color: #000;
    white-space: nowrap;
	font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .lang-badge {
    width: 1rem;
    height: 1rem;
    display: inline-flex;
    flex-shrink: 0;
  }

  .lang-badge--empty,
  .lang-drawer-item__arrow--empty {
    display: inline-block;
  }

  .lang-drawer-item__arrow {
    width: 0.4925rem;
    height: 0.8869rem;
    flex-shrink: 0;
  }
}

@media screen and (min-width: 768px) {
  .logo--mobile,
  .menu-btn--mobile,
  .mobile-drawer {
    display: none !important;
  }
}

</style>

<style lang="less">
.lang-dropdown,
.menucss{
	font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}
.lang-dropdown{
	min-width: 120px !important;
	padding: 6px 0;
	border: none;
	border-radius: 2px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
	.el-dropdown-menu__item{
		padding: 8px 20px;
		font-size: 14px;
		line-height: 22px;
		color: #000;
		&:hover,
		&:focus{
			background: #f5f5f5;
			color: #B50604;
		}
		&.active{
			font-weight: 400;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue